module.exports = __webpack_public_path__ + "media/assets/DefaultProfileIcon-47fedfba24254c805a036b9f85f32771.png";